var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { BorderRadius, Inset, Shape, getFocusStyles, withTheming } from '@doordash/design-language';
import styled, { css } from 'styled-components';
import { SizeNames } from './constants';
import { getColorSemantic } from './utils';
var PILL_BORDER_RADIUS = 1000;

var getDisplay = function getDisplay(props) {
  return props.isInline ? 'inline-flex' : 'flex';
};

export var SelectGroupButton = withTheming(styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n  display: ", ";\n  background-color: ", ";\n  min-height: ", "px;\n  width: auto;\n  align-items: center;\n  justify-content: center;\n  box-shadow: ", ";\n  border-radius: ", "px;\n  border: none;\n  color: ", ";\n  cursor: ", ";\n  transition: background-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  user-select: none;\n  text-decoration: none;\n  text-align: center;\n  &::-moz-focus-inner {\n    outline: none;\n    border-style: none;\n    padding: 0;\n  }\n  &:focus {\n    ", ";\n  }\n  &:hover {\n    background-color: ", ";\n    box-shadow: ", ";\n    color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n    box-shadow: ", ";\n    color: ", ";\n  }\n"])), getDisplay, function (props) {
  return props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Background'
  })];
}, function (props) {
  return props.theme.Size["Button".concat(SizeNames[props.size])];
}, function (props) {
  return "inset 0 0 0 ".concat(props.isSelected ? props.theme.BorderWidth["Button".concat(props.kind, "ToggleGroupOn")] : props.theme.BorderWidth["Button".concat(props.kind, "ToggleGroupOff")], "px ").concat(props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Border'
  })]);
}, function (props) {
  return props.kind.includes('PILL') || props.theme.Shape.ButtonDefault === Shape.Pill ? PILL_BORDER_RADIUS : props.theme.BorderRadius.ButtonDefault;
}, function (props) {
  return props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Foreground'
  })];
}, function (props) {
  return props.isDisabled ? 'not-allowed' : 'pointer';
}, getFocusStyles(), function (props) {
  return props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Background',
    state: 'Hovered'
  })];
}, function (props) {
  return "inset 0 0 0 ".concat(props.theme.BorderWidth["Button".concat(props.kind, "Toggle")], "px ").concat(props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Border',
    state: 'Hovered'
  })]);
}, function (props) {
  return props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Foreground',
    state: 'Hovered'
  })];
}, function (props) {
  return props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Background',
    state: 'Pressed'
  })];
}, function (props) {
  return "inset 0 0 0 ".concat(props.theme.BorderWidth["Button".concat(props.kind, "Toggle")], "px ").concat(props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Border',
    state: 'Pressed'
  })]);
}, function (props) {
  return props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Foreground',
    state: 'Pressed'
  })];
}));
export var SelectGroupContainer = withTheming(styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-radius: ", "px;\n  ", ";\n  & > * {\n    ", ";\n    border-radius: ", " !important;\n  }\n  & > * + * {\n    margin-left: -1px !important;\n  }\n  ", ";\n"])), function (props) {
  return props.kind.includes('PILL') || props.theme.Shape.ButtonDefault === Shape.Pill ? PILL_BORDER_RADIUS : props.theme.BorderRadius.ButtonDefault;
}, function (props) {
  return !props.isInline ? css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          display: flex;\n          width: 100%;\n        "]))) : css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          display: inline-block;\n          max-width: 100%;\n        "])));
}, function (props) {
  return !props.isInline ? css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            flex: 1;\n          "]))) : '';
}, BorderRadius.None, function (props) {
  var borderRadiusValue = props.kind.includes('PILL') || props.theme.Shape.ButtonDefault === Shape.Pill ? 1000 : props.theme.BorderRadius.ButtonDefault;
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      background-color: ", ";\n\n      & > *:first-child {\n        border-radius: ", "px 0 0 ", "px !important;\n      }\n      & > *:last-child {\n        border-radius: 0 ", "px ", "px 0 !important;\n      }\n      & > *:nth-child(", ") {\n        z-index: 1 !important;\n      }\n      ", ";\n    "])), props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Background'
  })], borderRadiusValue, borderRadiusValue, borderRadiusValue, borderRadiusValue, props.selectedIndex + 1, props.selectedIndex !== null && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n        & > *:nth-child(", ") {\n          border-radius: ", "px !important;\n        }\n        & > *:nth-child(", ") {\n          margin-right: -", "px !important;\n          padding-right: ", "px;\n        }\n        & > *:nth-child(", ") {\n          margin-left: -", "px !important;\n          padding-left: ", "px;\n        }\n      "])), props.selectedIndex + 1, borderRadiusValue, props.selectedIndex, props.size, props.size, props.selectedIndex + 2, props.size, props.size));
}));
export var TextOverflow = styled(Inset).attrs({
  verticalSize: Inset.Sizes.None,
  horizontalSize: function horizontalSize(props) {
    return props.size;
  }
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));